<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { useNuxtApp } from '#app';
import AOS from 'aos';
import 'aos/dist/aos.css';

const props = defineProps({
  options: {
    type: Object,
    default: () => ({
      once: true,
      duration: 600,
      easing: 'ease-out',
      offset: 0,
    }),
  },
  refreshOnRoute: { type: Boolean, default: true },
});

const rootEl = ref(null);

let observer;
let rafId;

const scheduleAosRefresh = () => {
  if (process.server) return;

  if (rafId) cancelAnimationFrame(rafId);
  rafId = requestAnimationFrame(() => {
    try {
      AOS.refreshHard();

      // щоб анімація відпрацьовувала одразу для елементів у viewport
      window.dispatchEvent(new Event('scroll'));
    } catch (e) {
      // noop
    }
  });
};

onMounted(() => {
  const isBot = /bot|googlebot|crawler|spider|robot|crawling|google web preview|chrome-lighthouse/i.test(
    navigator.userAgent
  );

  if (isBot) {
    document.documentElement.classList.add('aos-not-active');
    document.querySelectorAll('[data-aos]').forEach((el) => {
      el.removeAttribute('data-aos');
    });
    return;
  }

  AOS.init(props.options);
  document.documentElement.classList.add('aos-initialized'); // ← додати
  scheduleAosRefresh();

  if (props.refreshOnRoute) {
    const nuxtApp = useNuxtApp();
    nuxtApp.hook('page:finish', () => scheduleAosRefresh());
  }

  if (rootEl.value && typeof MutationObserver !== 'undefined') {
    observer = new MutationObserver(() => scheduleAosRefresh());
    observer.observe(rootEl.value, { childList: true, subtree: true });
  }
});

onBeforeUnmount(() => {
  if (rafId) cancelAnimationFrame(rafId);
  if (observer) observer.disconnect();
});
</script>

<template>
  <div ref="rootEl">
    <slot />
  </div>
</template>
